import { FC } from "react";
import { Command } from "@vendor/cmdk/cmdk";
import { pluralize } from "@common/helpers/string";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { CommandsListProps } from "./lib";
import { useCommands } from "./useCommands";

export const GetDocumentsBulkCommandsList: FC<CommandsListProps> = ({
    options = {},
}) => {
    const { close } = useCommands();
    const {
        selectedGetDocumentsCount = 0,
        onGetDocumentsBulkRemoveFromTask,
        onGetDocumentsBulkAskAbout,
    } = options;

    const heading = `${selectedGetDocumentsCount} ${pluralize("row", selectedGetDocumentsCount)} selected`;

    return (
        <Command.Group heading={heading}>
            {onGetDocumentsBulkRemoveFromTask && (
                <CommandItem
                    keywords={["remove", "detach", "unlink"]}
                    onSelect={() => {
                        close();
                        onGetDocumentsBulkRemoveFromTask();
                    }}
                >
                    Remove from task
                </CommandItem>
            )}
            {onGetDocumentsBulkAskAbout && (
                <CommandItem
                    keywords={["add", "ask", "chat", "comment"]}
                    onSelect={() => {
                        close();
                        onGetDocumentsBulkAskAbout();
                    }}
                >
                    Add to chat
                </CommandItem>
            )}
        </Command.Group>
    );
};
